import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Search } from 'lucide-react';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Link to="/" className="flex items-center">
                <Search className="h-8 w-8 text-indigo-600" />
                <h1 className="ml-2 text-2xl font-bold text-gray-900">
                  Grant Research Assistant
                </h1>
              </Link>
              <p className="ml-10 text-sm text-gray-600 mt-1">
                Discover the perfect funding opportunities for your organization
              </p>
            </div>
          </div>
        </div>
      </header>
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
      <footer className="bg-white border-t mt-auto">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center space-y-2">
            <div className="text-sm text-gray-500 space-x-4">
              <Link to="/privacy-policy" className="hover:text-indigo-600">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="hover:text-indigo-600">
                Cookie Policy
              </Link>
            </div>
            <div className="text-sm text-gray-400">
              © {new Date().getFullYear()} Grant Research Assistant. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}